<template>
    <div class="folder" :class="{'open' : showChildren}">
        <div class="d-flex align-items-center folder-header" >
            <button class="btn btn-link folder-name mb-0 me-auto" @click="showChildren = !showChildren">
                    <i class="fa fa-folder text-primary folder-icon me-1" ></i>
                    <span class="me-2">
                        <span v-if="!isRoot">{{folder.name}}</span>
                        <span v-else>Active</span>
                    </span>
                    <small class="d-none d-sm-block d-lg-inline">Topics ({{myTopics.length}}) Folders ({{children.length}})</small>

            </button>


            <span class="d-flex align-items-center text-center" style="line-height: 15px">
                <span class="add-folder" style="min-width:90px;">
                    <a v-if="features.editAssignmentsModal && !isRootFolder" class="d-block d-sm-inline" :aria-label="'Change folder Assignments'" href="#" @click.prevent="editAssignments">
                        <i class="fa fa-lock"></i> Assignments
                    </a>

                    <a v-if="canAddFolders" class="d-block d-sm-inline ms-0 ms-sm-3" :aria-label="'Add folder to '+folder.name" href="#" @click.prevent="newFolder">
                        <i class="fa fa-plus"></i> Add folder
                    </a>

                    <a v-if="!isRoot && ! isReviewer" class="d-xs-block d-sm-inline ms-0 ms-sm-3" :aria-label="'Delete '+folder.name" href="#" @click.prevent="deleteFolder(folder)">
                        <i class="fa fa-trash"></i> Delete folder
                    </a>
                </span>

                <a href="#" :aria-label="'Toggle open '+folder.name" v-if="!isRoot" class="c-pointer ms-3"  @click.prevent="showChildren = !showChildren">
                    <i class="fa fa-chevron-up" v-if="showChildren"></i>
                    <i class="fa fa-chevron-down" v-else></i>
                </a>
            </span>
        </div>


        <div class="children" :class="{'open' : showChildren || isMovingTopics}" v-if="showChildren || isMovingTopics">
            <button :aria-label="'Move selected topics to '+folder.name" @click="moveTopicsHere" class="mt-2 btn btn-success btn-sm mb-2" v-if="isMovingTopics"><i class="fa fa-arrow-up"></i> Move topics here</button>
            <div class="empty-folder mt-2" v-if="myTopics.length == 0 && children.length == 0 && !isMovingTopics">This folder is empty</div>
            <template v-if="!isMovingTopics">
                <div
                v-for="(topic) in myPaginatedTopics"
                :key="topic.id+'-topic-item'"
                class="topic-container d-flex"
                :class="{'selected' : selectedTopics.indexOf(topic.id) > -1}"

                @click="toggleTopic(topic)"
                :tabindex="0"
                :aria-label="'Topic: '+topic.name"
                @keyup.enter="toggleTopic(topic)"
            >
                <span  v-text="$strings.truncate(topic.name)" />
                <span class="topic-controls ms-auto" v-if="!isReviewer && !topic.incomplete">
                    <a class="ms-2 small" href="#" @click.prevent.stop="editTopic(topic)"><i class="fa fa-edit"></i> Edit</a>
                    <a class="ms-2 small" href="#" @click.prevent.stop="duplicateTopic(topic)"><i class="fa fa-copy"></i> Duplicate</a>
                    <a class="ms-2 small" href="#" @click.prevent.stop="deactivateTopic(topic)"><i class="fa fa-trash"></i> Deactivate</a>
                </span>
            </div>
            </template>
            <paginator :stay-on-first-page="true" :small="true" :size="10" :items="myTopics" @update="myPaginatedTopics = $event" />


            <folder-display
                @topicsSelected="childrenTopicsSelected"
                v-for="folder in children"
                :key="folder.id+'-folder'"
                :folder="folder"
                :folders="folders"
                :isMovingTopics="isMovingTopics"
                @topicAdded="addTopic"
                @topicRemoved="removeTopic"
                @createFolderWithNameInFolder="createFolderWithNameInFolder"
                @deactivateTopic="deactivateTopic"
                @childOpened="showChildren = true;"
            />
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Paginator from '@/utilities/Paginator'
import Roles from '@/utilities/Roles'


export default {
    name : 'folder-display',
    props : ['folder', 'isRoot', 'isMovingTopics'],
    mixins : [Roles],
    components : {
        Paginator
    },
    computed : {
        accountTopics(){
            if (!this.account) return [];
            return this.topics.filter(t => t.account.includes(this.account.id));
        },
        children(){
            let children = this.folders.filter(f => f.parents.find(p => p.includes(this.folder.id)));
            return this.$sort.alphabetize(children);
        },
        myTopics(){
            return this.$sort.alphabetize(this.topics.filter(t => t.folder.includes(this.folder.id)))
        },
        items(){
            return this.children.concat(this.myTopics)
        },
        canAddFolders(){
            return this.subscriptionPlan;
        },
        isRootFolder() {
            return this.folder.parents.length === 0;

        },
        ...mapGetters({
            topics : 'topics',
            folders : 'folders',
            account : 'currentAccount',
            currentTopic : 'currentTopic',
            subscriptionPlan : 'subscriptionPlan',
            features: 'accountFeatures',
        })
    },
    data(){
        return {
            showChildren : this.isRoot,
            selectedTopics : [],
            myPaginatedTopics : []
        }
    },
    watch : {
        myPaginatedTopics(){
            let incomplete = this.myPaginatedTopics.filter(t => t.incomplete);
            incomplete.forEach( t => {
                this.$api.get(`/topics/${t.id}`)
                .then( response => {
                    let topic = response.data;
                    this.$store.dispatch('addTopic', {topic});
                })
                .catch( () => {})
            })
        }
    },
    mounted(){
        window.Events.$on('selectedTopicsMovedToNewFolder', () => {
            this.selectedTopics = [];
        })
    },
    methods : {
        childrenTopicsSelected({topics}){
            this.selectedTopics = this.selectedTopics.concat(topics);
        },
        moveTopicsHere(){
            window.Events.$emit('folderSelectedForTopics', {folder : this.folder});
            this.showChildren = true;
            this.$emit('childOpened')
        },
        deleteFolder(){
            if (this.items.length){
                let x = confirm("Are you sure? Everything in this folder will be deleted, and you won't be able to recover it.");
                if (! x ) return;
            }

            let folder = this.folder;

            this.$store.dispatch('deleteFolder', {folder});
            this.$api.delete('/accounts/'+this.account.id+'/folders/'+folder.id).catch(() => {
                alert("You are not allowed to delete this folder");
                this.$store.dispatch('addFolder', {folder});
            }).then(() => {
                let allFolders = this.folders;
                let store = this.$store;
                function deleteChildren(folder){
                    folder.children.forEach(folderUrl => {
                        let childFolder = allFolders.find(f => folderUrl.includes(f.id));
                        if (childFolder){
                            store.dispatch('deleteFolder', {folder : childFolder});
                            deleteChildren(childFolder)
                        }
                    })
                }

                deleteChildren(folder);
            });

        },
        addTopic(topic){
            this.$emit('topicAdded', topic);
        },
        removeTopic(topic){
            this.$emit('topicRemoved', topic);
        },
        toggleTopic(topic){
            let index = this.selectedTopics.indexOf(topic.id);
            if (index > -1){
                this.selectedTopics.splice(index, 1)
                this.removeTopic(topic)
            } else {
                this.selectedTopics.push(topic.id)
                this.addTopic(topic)
            }
        },
        createFolderWithNameInFolder({name, folder}){
            this.$emit('createFolderWithNameInFolder', {name, folder})
        },
        newFolder(){
            let x = prompt('Enter a name for the new folder');
            if (x){
                this.createFolderWithNameInFolder({name : x, folder : this.folder});
                this.showChildren = true;
            }
        },
        editAssignments() {
            window.Events.$emit('show_folderAssignmentsModal', {folderId: this.folder.id, account: this.account})
        },
        editTopic(topic){
            window.Events.$emit('showQueryBuilderModal', { topic, mode : 'advanced' });
        },
        duplicateTopic(dTopic){
            let topic = {...dTopic, id : false, name : dTopic.name + ' - Copy' };
            window.Events.$emit('showQueryBuilderModal', { topic, mode : 'advanced' } );
        },
        deactivateTopic(topic){
            this.$emit('deactivateTopic', topic);
        }
    }
}
</script>

<style scoped>

.folder {
    margin-bottom: 5px;
}

.folder-icon {
    opacity: 0.8;
}

.topic-container {
    padding: 4px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.topic-container {
    display: flex;
}

.topic-container .topic-controls a {
    opacity: 0;
    font-size: var(--font-size-13);
    color: rgb(114, 112, 131);
}

.topic-container .topic-controls a:focus,
.topic-container:hover .topic-controls a,
.topic-container:focus .topic-controls a
{
    opacity: 1;
}

@media screen and (max-width: 575px) {
    .topic-container {
        display:block !important;
        border-bottom: 1px solid #aeaeae;
        margin-bottom: 1em;
    }
    .topic-container .topic-controls {
        display: block !important;
    }
    .topic-container .topic-controls a {
        opacity: 1
    }
}

.topic-container.selected,
#app .topic-container.selected a{
    background: var(--primary-50);
    color: white;
}
.topic-container.selected:hover {
    background: var(--primary-50);
    color: rgb(255, 255, 255);
}

.topic-container:hover {
    background: rgba(150, 146, 157, 0.319);
}

.topic-container {
    background: white;
    padding: 5px 10px;
}

.topic-container:hover .topic-controls, .topic-container:focus .topic-controls {
    opacity: 1;
}

.selected .topic-controls a {
    color: white;
}

.topic-container label {
    margin-bottom: 0;
    cursor: pointer;
    flex: 1;
    margin-right: 5px;
}

.folder-header {
    background: linear-gradient(rgb(231, 231, 234) 40%, #F0F0F0 80% );
    border-bottom: 1px solid rgba(255,255,255,0.2);
    font-weight: 400;
    height: 40px;
    padding: 4px 10px;
}

.folder-name {
    font-size: var(--font-size-14);
    margin-bottom: 3px;
    margin-top: 3px;
    padding: 0;
    color: var(--steel-0);
    text-decoration: none;
    box-shadow: none!important;
}

.children {
    padding-left: 10px;
    /*max-height: 0;*/
    overflow-y: auto;
}

.children.open {
    /*max-height: 450px;*/
}

.empty-folder {
    color: #7b7b7b;
    font-style: italic;
    font-size: var(--font-size-13);
    padding: 10px;
}

.add-folder a {
    font-size: var(--font-size-13);
    color: #555;
}

</style>
